import { render, staticRenderFns } from "./report_improve.vue?vue&type=template&id=3d45884d&scoped=true"
import script from "./report_improve.vue?vue&type=script&lang=js"
export * from "./report_improve.vue?vue&type=script&lang=js"
import style0 from "./report_improve.vue?vue&type=style&index=0&id=3d45884d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d45884d",
  null
  
)

export default component.exports